import { HomeMyInvoicesApi, HomeMyInvoicesSingleApi } from '@core/api/model/home/home-my-invoices-api.model';
import { HomeMyInvoices, HomeMyInvoicesSingle } from '@core/domain/model/home/home-my-invoices.model';
import { TagTransformer } from '@core/domain/mappers/assistants/tag.transformer';
import { InvoiceStatusCode } from '@core/domain/model/invoices/my-invoices-listing.model';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';

export class HomeMyInvoicesMapper {
  public static modelFromApi(api: HomeMyInvoicesApi, ggccSocieties?: MasterSocietyModel[]): HomeMyInvoices {
    return {
      facturas: api.facturas.map((value) => HomeMyInvoicesMapper.invoiceModelFromApi(value, ggccSocieties)).slice(0, 4),
    };
  }

  private static invoiceModelFromApi(input: HomeMyInvoicesSingleApi, ggccSocieties?: MasterSocietyModel[]): HomeMyInvoicesSingle {
    let shouldShowTag = false;
    switch (input.codEstado) {
      case InvoiceStatusCode.PENDING_PAYMENT:
      case InvoiceStatusCode.OVERDUE:
      case InvoiceStatusCode.CONTESTED:
      case InvoiceStatusCode.RETURNED:
        shouldShowTag = true;
        break;
    }
    let status;
    if (shouldShowTag) {
      status = TagTransformer.tagFromInvoice(
        input.codEstado,
        input.codigoNivelReclamacion,
        input.parado,
        ggccSocieties?.map((value) => value.codigo).includes(input.codigoRazonSocial) ?? false
      );
    }
    return {
      id: input.numeroFactura,
      societyName: input.nombreRazonSocial,
      installationName: input.nombreInstalacion,
      cups: input.cups,
      amount: input.importe,
      consumption: input.consumo,
      startDateSupply: input.fechaInicioSuministro,
      endDateSupply: input.fechaFinSuministro,
      idDCTM: input.idDCTM,
      statusId: input.codEstado,
      status: status?.description,
      statusTag: status?.tag,
      showTag: shouldShowTag,
    };
  }
}
